import { useEffect, useState } from "react";
import { sendPostRequest } from "@/utils/sendPostRequest";

export type Address = {
  street: string;
  rawAddress: string | null;
  zipCode: string;
  city: string;
  country: string;
};
export type CompanyProposition = {
  siret: string;
  businessName: string;
  nafCode: string;
  address: Address;
};

type FetchResponse = CompanyProposition[];

export const useFetchAutocompleteCompanies = (
  searchText: string
): {
  companies: CompanyProposition[];
  isLoading: boolean;
  isError: boolean;
} => {
  const [companies, setCompanies] = useState<FetchResponse>([]);
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);

  useEffect(() => {
    setError(false);
    if (searchText.length < 3) {
      setCompanies([]);

      return;
    }
    setLoading(true);
    sendPostRequest({
      url: "/customers/v1/business/search",
      body: JSON.stringify({
        searchText: searchText,
      }),
      additionalHeaders: [{ name: "Content-Type", value: "application/json" }],
    })
      .then((fetchedCompanies: FetchResponse) => {
        setCompanies(fetchedCompanies);
      })
      .catch(() => {
        setError(true);
        setCompanies([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchText]);

  return { companies, isLoading, isError };
};
